const noOpGenerator = function* () {};

export function isGenerator(arg) {
  return (
    arg.constructor === noOpGenerator.constructor ||
    arg.constructor.name === "GeneratorFunction"
  );
}
